import { AnyAction } from 'redux';
import { ActionTypes } from '../constants/index';
import { LoginDetails } from '../modal';

export default function reducer(state: LoginDetails = new LoginDetails(), action: AnyAction) {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.LOGIN_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loadingInProgress: true,
      };
    case ActionTypes.LOGIN_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loadingInProgress: false,
        data: payload,
      };
    case ActionTypes.LOGIN_DETAILS_LIST_ERROR:
      return {
        ...state,
        loadingInProgress: false,
        loadingError: payload,
      };
    default:
      return state;
  }
}
